import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import Layout from "../components/Layout";
import { useForm } from "react-hook-form";
import client from "../utils/client";

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { register: registerA, handleSubmit: handleSubmitA } = useForm();
  const { register: registerB, handleSubmit: handleSubmitB } = useForm();

  const handleSubmitLogin = async (data) => {
    setIsLoading(true);
    try {
      await auth.signin(data, () => navigate("/", { replace: true }));
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitPassword = async (data) => {
    setIsLoading(true);
    try {
      await client.post(`/users/recover`, data).then(() => setIsLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <Flex
        minH="calc(100vh - 8rem)"
        alignItems="center"
        justifyContent="center"
        py={[8, 12]}
        px={4}
      >
        <Box
          w={["100%", "90%", "480px"]}
          bg="white"
          borderRadius="1.5rem"
          boxShadow="0 8px 40px rgba(0,0,0,0.10)"
          overflow="hidden"
        >
          {/* Header stripe */}
          <Box
            bg="green.600"
            py={6}
            px={8}
            display="flex"
            flexDir="column"
            alignItems="center"
            gap={3}
          >
            <Image
              src={process.env.PUBLIC_URL + "/logoBig.png"}
              h="4rem"
            />
            <Heading color="white" fontSize="1.5rem" textAlign="center">
              Acesse sua conta
            </Heading>
          </Box>

          <Box px={[6, 8]} py={8}>
            <form id="a" onSubmit={handleSubmitA(handleSubmitLogin)}>
              <FormControl isRequired>
                <Flex gap={4} flexDir="column">
                  <Box>
                    <FormLabel htmlFor="email" color="gray.700" fontWeight={600}>
                      E-mail
                    </FormLabel>
                    <Input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="seu@email.com"
                      {...registerA("email")}
                    />
                  </Box>
                  <Box>
                    <FormLabel htmlFor="password" color="gray.700" fontWeight={600}>
                      Senha
                    </FormLabel>
                    <Input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="••••••••"
                      {...registerA("password")}
                    />
                  </Box>
                  <Button
                    isLoading={isLoading}
                    type="submit"
                    colorScheme="green"
                    size="lg"
                    w="100%"
                    mt={2}
                  >
                    Entrar
                  </Button>
                </Flex>
              </FormControl>
            </form>

            <Divider my={6} />

            <Text fontWeight={700} color="gray.600" mb={3}>
              Esqueceu sua senha?
            </Text>
            <form id="b" onSubmit={handleSubmitB(handleSubmitPassword)}>
              <Flex gap={3} flexDir="column">
                <Input
                  id="emailRecover"
                  name="emailRecover"
                  type="email"
                  placeholder="Informe seu e-mail cadastrado"
                  {...registerB("email")}
                />
                <Button
                  isLoading={isLoading}
                  type="submit"
                  colorScheme="green"
                  variant="outline"
                  w="100%"
                >
                  Recuperar senha
                </Button>
              </Flex>
            </form>
          </Box>
        </Box>
      </Flex>
    </Layout>
  );
};

export default Login;
